<template>
    <div>
        <brand-form
            :entity-id="id"
            :store-restaurant-ids="storeRestaurantIds"
            :refresh-restaurants="restaurantsRefresh"
            @updated="onBrandUpdated"
        ></brand-form>
        <brand-stores
            v-if="brandId"
            :brand-id="brandId"
            :reload="storesReload"
            @loaded="onStoresLoaded"
            @changed="onStoresChanged"
        ></brand-stores>
    </div>
</template>

<script>
import DirtyFormMixin from '@/mixins/DirtyForm'
import BrandForm from './parts/BrandForm.vue'
import BrandStores from './parts/BrandStores.vue'

export default {
    components: { BrandForm, BrandStores },
    mixins: [DirtyFormMixin],
    props: {
        id: {
            type: [String, Number],
            default: null,
        },
    },
    data() {
        return {
            storeRestaurantIds: [],
            storesReload: 0,
            restaurantsRefresh: 0,
        }
    },
    computed: {
        brandId() {
            return this.id ? Number(this.id) : null
        },
    },
    methods: {
        onStoresLoaded(stores) {
            this.storeRestaurantIds = stores.flatMap((store) =>
                store.restaurants.map((restaurant) => restaurant.id)
            )
        },
        onStoresChanged() {
            // store membership changed → the brand form's selector must refetch storeId values
            this.restaurantsRefresh++
        },
        onBrandUpdated() {
            // a brand save can detach store members through the backend cascade
            this.storesReload++
            this.restaurantsRefresh++
        },
    },
}
</script>
